import React from 'react';
// components
import Header from './components/Header';
import Footer from './components/Footer';
// pages
import Home from './pages/Home';
import RoomDetails from './pages/RoomDetails';

import './i18n.js'
// react router
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ErrPage from './components/ErrPage.js';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/room/:id',
    element: <RoomDetails />,
  },
  {
    path: '/package/:id',
    element: '',
  },
  {
    path: '/rooms',
    element: '',
  },
  {
    path: '*',
    element: <ErrPage/>
  }
]);

const App = () => {
  return (
    <div>
      <Header />
      <RouterProvider router={router} />
      <Footer />
    </div>
  );
};

export default App;
